export default __webpack_public_path__ + "static/media/background-4.0360b1a7.jpg";